import routes from "@/constants/routes";
import { Listing, RibbonType } from "@/services/apiTypes";
import { getReferrer } from "@/shared/hooks/useReferralTracker";
import { getAllStoredUTMParams } from "@/shared/hooks/useUTMTracker";
import getConfig from "next/config";

const { publicRuntimeConfig } = getConfig();

const viewingLinks: Record<string, string> = {
  hayes: publicRuntimeConfig.NEXT_PUBLIC_VIEWING_LINK_HAYES,
  southall: publicRuntimeConfig.NEXT_PUBLIC_VIEWING_LINK_SOUTHALL,
  harrow: publicRuntimeConfig.NEXT_PUBLIC_VIEWING_LINK_HARROW,
};

export function getPropertyViewingLink(
  location: string,
  mondayPropertyId: string,
  propertyId: string,
): string {
  if (publicRuntimeConfig.NEXT_ENABLE_CALENDAR === "1") {
    return routes.bookViewing.bookPropertyViewing({ slug: location, id: propertyId });
  }

  const defaultViewingLink = `${
    publicRuntimeConfig.NEXT_TYPEFORM_NOW_REGISTER_INTEREST_URL
  }#monday_property_id=${mondayPropertyId}&${getAllStoredUTMParams()}&referred_by=${getReferrer()}`;

  if (!location) return defaultViewingLink;

  const key = location.trim().toLowerCase();
  return viewingLinks[key] ?? defaultViewingLink;
}

export function getPropertyLoaderImage(development: string) {
  switch (development) {
    case "wandsworth":
      return "/properties/wandsworth/building-low-wandsworth.jpg";
    case "southall":
      return "/properties/southall/building-low-southall.jpg";
    case "harrow":
      return "/properties/harrow/building-low-harrow.jpg";
    case "hayes":
      return "/properties/hayes/building-low-hayes.jpg";
    default:
      return "/properties/building-low.jpg";
  }
}

export function getRibbonSource(ribbonType: RibbonType) {
  switch (ribbonType) {
    case "let":
      return "/icons/let-ribbon.png";
    case "justAdded":
      return "/icons/just-added.png";
    case "reserved":
      return "/icons/reserved-ribbon.png";
    case "comingSoon":
      return "/icons/new-coming-soon-ribbon.png";
    default:
      return "/icons/just-added.png";
  }
}
